import { render, staticRenderFns } from "./MyLightBox.vue?vue&type=template&id=059145dc&scoped=true"
import script from "./MyLightBox.vue?vue&type=script&lang=js"
export * from "./MyLightBox.vue?vue&type=script&lang=js"
import style0 from "./MyLightBox.vue?vue&type=style&index=0&id=059145dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059145dc",
  null
  
)

export default component.exports